/**
 * "Action confirmation & risk" — Core Concepts (ADR-0074).
 * Reconciled from product/failure-and-quality/action-confirmation.md, the widget
 * ConfirmCard/ActionPlan surfaces, and the MCP action-gate behaviour.
 */
import type { DocPageContent } from '../types';

export const CONFIRMATION_PAGE: DocPageContent = {
  slug: 'confirmation',
  titleKey: 'docs.concepts.confirmation.title',
  descriptionKey: 'docs.concepts.confirmation.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.concepts.confirmation.lead' },

    { kind: 'heading', level: 2, id: 'tiers', textKey: 'docs.concepts.confirmation.tiers.heading' },
    {
      kind: 'definitions',
      items: [
        {
          termKey: 'docs.concepts.confirmation.tier.read.term',
          descKey: 'docs.concepts.confirmation.tier.read.desc',
        },
        {
          termKey: 'docs.concepts.confirmation.tier.write.term',
          descKey: 'docs.concepts.confirmation.tier.write.desc',
        },
        {
          termKey: 'docs.concepts.confirmation.tier.destructive.term',
          descKey: 'docs.concepts.confirmation.tier.destructive.desc',
        },
      ],
    },

    { kind: 'heading', level: 2, id: 'plans', textKey: 'docs.concepts.confirmation.plans.heading' },
    { kind: 'paragraph', textKey: 'docs.concepts.confirmation.plans.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'who-sets',
      textKey: 'docs.concepts.confirmation.whoSets.heading',
    },
    { kind: 'paragraph', textKey: 'docs.concepts.confirmation.whoSets.body' },

    { kind: 'heading', level: 2, id: 'mcp', textKey: 'docs.concepts.confirmation.mcp.heading' },
    { kind: 'paragraph', textKey: 'docs.concepts.confirmation.mcp.body' },

    {
      kind: 'callout',
      tone: 'important',
      titleKey: 'docs.concepts.confirmation.note.title',
      textKey: 'docs.concepts.confirmation.note.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.concepts.confirmation.next.identity.title',
          textKey: 'docs.concepts.confirmation.next.identity.text',
          to: { docSlug: 'identity' },
        },
        {
          titleKey: 'docs.concepts.confirmation.next.catalog.title',
          textKey: 'docs.concepts.confirmation.next.catalog.text',
          to: { docSlug: 'catalog' },
        },
      ],
    },
  ],
};
